import { SettingLayoutComponentId } from '@starsoft/common/models';
import dynamic from 'next/dynamic';

const LayoutV1 = dynamic(() => import('./v1'), { ssr: true });
const LayoutV2 = dynamic(() => import('./v2'), { ssr: true });
const LayoutV3 = dynamic(() => import('./v3'), { ssr: true });
const LayoutV4 = dynamic(() => import('./v4'), { ssr: true });

export function UserRankCard({ id }: { id: string }) {
  switch (id) {
    case SettingLayoutComponentId.UserProfileChipV1?.toString():
    default:
      return <LayoutV1 />;
    case SettingLayoutComponentId.UserProfileChipV2?.toString():
      return <LayoutV2 />;
    case SettingLayoutComponentId.UserProfileChipV3?.toString():
      return <LayoutV3 />;
    case SettingLayoutComponentId.UserProfileChipV4?.toString():
      return <LayoutV4 />;
  }
}
